const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m55 22v-1h-6v1c0 .551.448 1 1 1h4c.552 0 1-.449 1-1z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.721 25 2 6h.559l2-6h1.72c-1.302 0-2.402-.839-2.816-2h-27.184c-.552 0-1 .449-1 1v12c0 .552.448 1 1 1h32c.552 0 1-.448 1-1v-11h-2v10h-2v-5.838l-1.279 3.838h-3.441l-1.28-3.838v5.838h-2v-10zm-18.721 8c1.103 0 2-.897 2-2h2c0 2.206-1.794 4-4 4s-4-1.794-4-4v-2c0-2.206 1.794-4 4-4s4 1.794 4 4h-2c0-1.103-.897-2-2-2s-2 .897-2 2v2c0 1.103.897 2 2 2zm14-1v3h-2v-3c0-.551-.448-1-1-1h-3v4h-2v-10h5c1.654 0 3 1.346 3 3 0 .771-.301 1.468-.78 2 .479.532.78 1.229.78 2z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 27h-3v2h3c.552 0 1-.449 1-1s-.448-1-1-1z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.501 16.053.499.288v2.659h2v-7.277c-.595-.346-1-.984-1-1.723 0-1.105.895-2 2-2s2 .895 2 2c0 .738-.405 1.376-1 1.723v7.277h2v-2.658l.499-.289c2.159-1.249 3.501-3.569 3.501-6.053 0-1.988-.851-3.89-2.333-5.217-1.301-1.165-2.931-1.783-4.658-1.783-.27 0-.541.015-.813.045-3.067.34-5.636 2.791-6.107 5.827-.451 2.901.888 5.719 3.412 7.181z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 51h-1-2-1c-.552 0-1 .448-1 1v6c0 1.654 1.346 3 3 3s3-1.346 3-3v-6c0-.552-.448-1-1-1z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52 39c-4.963 0-9 4.037-9 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9zm-1 8h2c1.654 0 3 1.346 3 3v3h-3v2h-2v-2c-1.654 0-3-1.346-3-3h2c0 .552.448 1 1 1h3v-1c0-.552-.448-1-1-1h-2c-1.654 0-3-1.346-3-3v-3h3v-2h2v2c1.654 0 3 1.346 3 3h-2c0-.552-.448-1-1-1h-3v1c0 .552.448 1 1 1z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 42c-6.627 0-12-5.373-12-12s5.373-12 12-12c3.04 0 5.81 1.137 7.925 3h4.069c-2.814-3.737-7.261-6-11.994-6-8.271 0-15 6.729-15 15s6.729 15 15 15c4.733 0 9.18-2.263 11.994-6h-4.075c-2.114 1.862-4.881 3-7.919 3z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 49c.552 0 1-.448 1-1v-1.125c-.66.078-1.327.125-2 .125-.678 0-1.343-.051-2-.128v1.128c0 .552.448 1 1 1z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrm);
export default __webpack_public_path__ + "static/media/crm.a07de718a4b5228a5a72856e0a103493.svg";
export { ForwardRef as ReactComponent };